var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetCaseUpdatesByIdQuery } from "@/store/api";
import { faChevronDown, faChevronUp, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link } from "react-router-dom";
var CaseUpdatesList = function (_a) {
    var caseId = _a.caseId, refreshKey = _a.refreshKey;
    var _b = useGetCaseUpdatesByIdQuery({ id: caseId, v: refreshKey }, { refetchOnMountOrArgChange: true }), _c = _b.data, updates = _c === void 0 ? [] : _c, isLoading = _b.isLoading, isError = _b.isError;
    var _d = useState({}), expandedItems = _d[0], setExpandedItems = _d[1];
    var _e = useState(true), allExpanded = _e[0], setAllExpanded = _e[1];
    var toggleItem = function (index) {
        setExpandedItems(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[index] = !prev[index], _a)));
        });
    };
    var toggleAll = function () {
        var newExpanded = !allExpanded;
        var updatedMap = {};
        updates.data.forEach(function (_, i) {
            updatedMap[i] = newExpanded;
        });
        setExpandedItems(updatedMap);
        setAllExpanded(newExpanded);
    };
    var handleDownload = function (file) {
        var link = document.createElement("a");
        link.href = file.base64;
        link.download = file.name; // filename for the download
        link.click();
    };
    if (isLoading)
        return _jsx("i", { children: "Loading case updates list..." });
    if (isError)
        return _jsx("p", { children: "Failed to load updates." });
    function decodeHtmlEntities(str) {
        var txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }
    return (_jsxs("div", __assign({ className: "text-[var(--colors-label)]" }, { children: [_jsx("div", __assign({ className: "flex items-center justify-between mb-2" }, { children: _jsx("button", __assign({ onClick: toggleAll, className: "text-sm text-blue-600 underline" }, { children: updates.data.length > 0 &&
                        (allExpanded ? "Collapse All" : "Expand All") })) })), updates.data.map(function (update, idx) {
                var _a;
                var isExpanded = (_a = expandedItems[idx]) !== null && _a !== void 0 ? _a : true;
                return (_jsxs("div", __assign({ className: "border p-3 mb-3  border-gray-300 bg-[var(--colors-body-bg-sec)]" }, { children: [_jsxs("div", __assign({ className: "flex  items-center mb-1" }, { children: [_jsx("button", __assign({ onClick: function () { return toggleItem(idx); }, className: " " }, { children: isExpanded ? (_jsx(FontAwesomeIcon, { icon: faChevronUp })) : (_jsx(FontAwesomeIcon, { icon: faChevronDown })) })), _jsxs("div", __assign({ className: "text-sm text-gray-700 font-semibold ml-3" }, { children: [update.last_name, " \u2014", " ", new Date(update.date_entered).toLocaleString()] }))] })), isExpanded && (_jsxs(_Fragment, { children: [update.attachments && update.attachments.length > 0 && (_jsxs("div", __assign({ className: "mb-2 text-sm " }, { children: ["Attachments:\u00A0", update.attachments.map(function (file, i) { return (_jsx(Link, __assign({ to: "/modules/Notes/DetailView/".concat(file.id), className: "text-blue-600 underline mr-2 cursor-pointer" }, { children: file.filename || file.name }), i)); })] }))), _jsx("div", { className: "", dangerouslySetInnerHTML: {
                                        __html: decodeHtmlEntities((update === null || update === void 0 ? void 0 : update.description) || ""),
                                    } })] }))] }), idx));
            })] })));
};
export default CaseUpdatesList;
